<template>
<div class="meditation" ref="meditationWrapper">
  <transition name="aniInAndOut" appear mode="out-in">
    <div v-if="!startMeditation" class="info-wrapper loading-screen">
      <div class="loading-parts">

        <p class="">Hello and welcome to our chillout-area.<br> Let’s meditate together to awake your higher self <br>and make you feel fantastic</p>
        <!-- <span @click="handleStart" class="button">
        start meditation
      </span> -->
        <span @click="handleStart" class="styled-button">
        start meditation
      </span>
      </div>
    </div>
  </transition>
  <transition name="rt" mode="out-in">
    <div v-show="startMeditation" class="video-wrapper">
      <video ref="meditationVideo1" playsinline preload="auto">
          <source :src="videoSrc1" type="video/webm">
          <source :src="videoSrc1mp4" type="video/mp4">
      </video>
      <video ref="meditationVideo2" playsinline style="display: none" preload="auto" loop>
          <source :src="videoSrc2" type="video/webm">
          <source :src="videoSrc2mp4" type="video/mp4">
      </video>
      <audio ref="meditationSound">
          <source :src="soundSrc" type="audio/webm">
          <source :src="soundSrcMp3" type="audio/mp3">
      </audio>
    </div>
  </transition>
  <transition name="aniInAndOut" mode="out-in">
    <div v-if="showStop" class="meditation-stop">
      <span class="button" @click="handleStop()">Stop Meditation</span>
    </div>
  </transition>
</div>
</template>

<script>
// import cVideo from '@/components/video.vue'

export default {
  name: 'meditation',
  data() {
    return {
      showStop: false,
      startMeditation: false,
      videoSrc1: require('@/assets/videos/meditation_1.webm'),
      videoSrc2: require('@/assets/videos/meditation_2.webm'),
      videoSrc1mp4: require('@/assets/videos/meditation_1.mp4'),
      videoSrc2mp4: require('@/assets/videos/meditation_2.mp4'),
      soundSrc: require('@/assets/sounds/meditation-full.webm'),
      soundSrcMp3: require('@/assets/sounds/meditation-full.mp3'),
    }
  },
  methods: {
    handleVideos() {
      this.$refs.meditationVideo1.style.display = "none";
      this.$refs.meditationVideo2.style.display = "block";
      //this.$refs.meditationWrapper.classList.add('ani');
      this.$refs.meditationVideo2.play();
    },
    handleStart() {
      this.startMeditation = true;
      this.showStop = true;
      this.$root.$emit('navVisibilityOverride', true);
      this.$refs.meditationVideo1.play();
      this.$refs.meditationSound.play();
    },
    handleStop() {
      this.showStop = false;
      this.startMeditation = false;
      this.$root.$emit('navVisibilityOverride', false);
      this.$refs.meditationVideo1.pause();
      this.$refs.meditationVideo2.pause();
      this.$refs.meditationSound.pause();
      this.$refs.meditationVideo1.currentTime = 0;
      this.$refs.meditationVideo2.currentTime = 0;
      this.$refs.meditationSound.currentTime = 0;
      //this.$refs.meditationWrapper.classList.remove('ani');

    }
  },
  beforeDestroy() {
    this.$refs.meditationVideo1.removeEventListener("ended", this.handleVideos);
  },
  mounted() {
    this.$refs.meditationVideo1.addEventListener("ended", this.handleVideos, false);
  },

}
</script>

<style lang="scss">
.meditation {
    background: black;
    transition: background 10s ease;
    height: 100vh;
    video {
        width: 100%;
        height: 100%;
        object-fit: contain;
        margin: 0;
    }
    .button {
        color: $red;
        margin: 2rem;
        transition: border-color 1s ease;
        border-radius: 2rem;
        display: inline-block;
        /* background: black; */
        filter: drop-shadow(0px 0px 3px red) drop-shadow(0px 0px 7px black);
        padding: 0 1em 5px;
        cursor: pointer;
        // border-radius: 1em;
        // border: 2px solid white;
        border: 2px $red solid;

    }
    .meditation-stop {
        position: fixed;
        bottom: 0;
        width: 100%;
        margin: 2rem;

    }
}
.meditation.ani {
    background: white;
}
</style>
